module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Barthelemy-a20520048fb8ce1e1dfe0675df1c280a.png";